import Delete16 from '@carbon/icons-react/es/delete/16';
import Edit16 from '@carbon/icons-react/es/edit/16';
import React, { ReactNode } from 'react';
import { Category, CategoryId } from 'api/timesheets/categories';
import { Button } from 'components/atoms/button';
import { Tag } from 'components/atoms/tag';
import { Deleting } from 'core/state';
import { getRandomColor } from 'utils/get-random-color';
import { asList } from '../categories';
import { Actions } from './components';

type ElementType<A extends readonly unknown[]> = A extends readonly (infer T)[]
  ? T
  : never;
type CategoryT = ElementType<ReturnType<typeof asList>>;
type UndeletedCategory = Exclude<CategoryT, Deleting<Category>>;

export const columns = (
  count: number,
  listCaption: ReactNode,
  setEditing: (next: Category | null) => void,
  onDelete: (id: CategoryId) => void,
) => [
  {
    title: `${listCaption} (${count})`,
    key: 'category',
    render: (_value, [, { id, name }]: UndeletedCategory) => (
      <Tag color={getRandomColor(id)}>{name}</Tag>
    ),
  },
  {
    title: '',
    key: 'actions',
    className: 'actions',
    render: (_value, [, category]: UndeletedCategory) => (
      <Actions>
        <Button
          type="text"
          icon={<Edit16 />}
          onClick={() => setEditing(category)}
        />
        <Button
          type="text"
          icon={<Delete16 />}
          onClick={() => onDelete(category.id)}
        />
      </Actions>
    ),
  },
];
